module.exports = __webpack_public_path__ + "static/media/Gotham-Light.0ff4bccb.otf";